import styled from 'styled-components';
// Material UI
import Button from '@mui/material/Button';

const DialogActionButton = styled(Button)`
  min-width: 5rem;
`;

const DialogPrimaryButton = styled(DialogActionButton)`
  ${({ theme }) => `
    background-color: ${theme.palette.primary.main};
    color: ${theme.palette.primary.contrastText};

    &:hover {
      background-color: ${theme.palette.primary.main};
    }

    &:disabled {
        background-color: ${theme.palette.primary.light};
        color: ${theme.palette.primary.contrastText};
    }
  `}
`;

const DialogCancelButton = styled(DialogActionButton)`
  ${({ theme }) => `
    color: ${theme.palette.primary.main};
    background-color: ${theme.palette.primary.contrastText};
    border: solid 1px ${theme.palette.primary.main};

    &:hover {
      background-color: ${theme.palette.primary.contrastText};
    }
  `}
`;

const DialogSubmitButton = styled(DialogPrimaryButton).attrs(() => ({
    type: 'submit',
}))``;

export { DialogSubmitButton, DialogCancelButton, DialogPrimaryButton };
